<script setup lang="ts">
import { useInputCallbackTopic } from '../../../model/additional-info/support/info-callback-request/input-callback-topic.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import InputCallbackTopic from './info-callback-request/InputCallbackTopic.vue'

defineOptions({
  name: 'InfoCallbackRequest',
})

const { isRequired } = useInputCallbackTopic()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Callback topic"
      :required="isRequired"
    >
      <InputCallbackTopic />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
